/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { SectionHeaderCellModel } from "./SectionHeaderCellModel";
import { markType } from "igniteui-react-core";
/**
 * @hidden
 */
var TemplateSectionHeaderCellModel = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(TemplateSectionHeaderCellModel, _super);
    function TemplateSectionHeaderCellModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TemplateSectionHeaderCellModel.$t = markType(TemplateSectionHeaderCellModel, 'TemplateSectionHeaderCellModel', SectionHeaderCellModel.$);
    return TemplateSectionHeaderCellModel;
}(SectionHeaderCellModel));
export { TemplateSectionHeaderCellModel };
//# sourceMappingURL=TemplateSectionHeaderCellModel.js.map
